import React from "react";
import { Typography } from "antd";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

const { Text } = Typography;

const Item = (props) => {
  const { name, content, line_type } = props;
  const intl = useIntl();

  return (
    <div className="item_container">
      <Text type="secondary">
        {intl.formatMessage({
          id: "app.work_diary_print." + name,
        })}
      </Text>

      {content ? (
        <Text>{content}</Text>
      ) : (
        <div className={`horizontal_line ${line_type}`} />
      )}
    </div>
  );
};

Item.propTypes = {
  name: PropTypes.string,
  content: PropTypes.string,
};

export default Item;
